// import classNames from 'classnames';
import { Flex } from 'antd';

import {
  PriceSelectionItemDto,
  TenderSupplier,
} from '@Features/MaterialRequest/requests/components/ComparisonSheet/ComparisonSheet.types';
import { TenderTotalAmountResponse } from '@Types/api/form/tenderRequest/TenderTotalAmountResponse';
import PriceSelection from '@Features/MaterialRequest/requests/components/ComparisonSheet/PriceSelection/PriceSelection';
import PriceSelectionFooter from '@Features/MaterialRequest/requests/components/ComparisonSheet/PriceSelection/PriceSelectionFooter';

import { ReactComponent as NextArrowIcon } from '@Icons/additional/arrow-left.svg';
// import { ReactComponent as SearchIcon } from '@Icons/additional/search-gradient.svg';

import styles from './approve-tab.module.css';

interface ApproveTabDesktopProps {
  comparisonSheetSuppliers: TenderSupplier[];
  selectedSheetOffers: PriceSelectionItemDto[];
  totalAmountData: TenderTotalAmountResponse | undefined;
  handleOpenModal: () => void;
  handleBack: () => void;
}

const ApproveTabDesktop: React.FC<ApproveTabDesktopProps> = ({
  comparisonSheetSuppliers,
  handleBack,
  handleOpenModal,
  selectedSheetOffers,
  totalAmountData,
}) => {
  return (
    <>
      <Flex vertical className={styles.header}>
        <div className={styles.backSection}>
          <NextArrowIcon onClick={handleBack} /> Back
        </div>
        <div className={styles.overviewSection}>
          <div className={styles.overview}>Overview</div>
          {/* <div
            className={classNames(
              'trojan-neumorphism-box trojan-neumorphism-box-shadow',
              styles.searchButton
            )}
          >
            <SearchIcon />
          </div> */}
        </div>
      </Flex>
      <Flex flex="1 1 100%" className="overflow-hidden" align="stretch">
        <PriceSelection
          vendors={comparisonSheetSuppliers}
          dataSource={selectedSheetOffers}
          totalItems={selectedSheetOffers.length}
        />
      </Flex>
      <PriceSelectionFooter
        finalAmount={Number(totalAmountData?.finalTotAmount)}
        onApprove={handleOpenModal}
        onCancel={handleBack}
      />
    </>
  );
};

export default ApproveTabDesktop;
